import { Plane, Building2, CarFront, Binoculars, UtensilsCrossed, Sparkles, Route } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";

const SERVICES = [
  { icon: Plane, title: "Flights & Travel Arrangements", copy: "Travel arrangements based on your itinerary and requirements." },
  { icon: Building2, title: "Hotels & Resorts", copy: "Accommodation recommendations and arrangements suited to your journey." },
  { icon: CarFront, title: "Local Transport", copy: "Airport transfers, local transportation and other selected transport requirements." },
  { icon: Binoculars, title: "Sightseeing Activities", copy: "Sightseeing and activities based on your interests." },
  { icon: UtensilsCrossed, title: "Dining", copy: "Dining recommendations and arrangements where required." },
  { icon: Sparkles, title: "Experiences", copy: "Activities and experiences selected around your travel style." },
  { icon: Route, title: "Complete Trip Coordination", copy: "Coordination of the selected elements of your journey through one point of contact.", wide: true },
];

export const Services = () => (
  <section id="experiences" data-testid="services-section" className="bg-bone px-5 py-20 text-obsidian sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <ChapterTag index="05" label="What We Arrange" light />
      </Reveal>
      <div className="mt-10 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl font-light leading-tight tracking-tight sm:text-5xl">
            Everything Your <span className="italic text-gold-muted">Journey Needs.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-sm font-light leading-relaxed text-zinc-500">
            One conversation. One point of contact. Every detail of your journey, thoughtfully arranged.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={0.08 + i * 0.07} className={s.wide ? "sm:col-span-2 lg:col-span-3" : ""}>
            <div
              data-testid={`service-card-${i}`}
              className={`group h-full rounded-sm border border-black/10 bg-white p-8 transition-all duration-500 hover:-translate-y-2 hover:border-gold-muted/60 hover:shadow-2xl ${
                s.wide ? "flex flex-col items-start gap-6 sm:flex-row sm:items-center" : ""
              }`}
            >
              <s.icon size={26} strokeWidth={1.25} className="shrink-0 text-gold-muted" />
              <div>
                <h3 className="font-serif text-xl font-normal text-zinc-900 sm:text-2xl">{s.title}</h3>
                <p className="mt-3 max-w-2xl text-sm font-light leading-relaxed text-zinc-500">{s.copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
